/* ==========================================================================
   APP
   ========================================================================== */

import './scripts/app.ts';
import './styles/app.css';